export default function CsWebApplicationAttacks() {
  return (
    <h2>Cs Web Application Attacks</h2>
  );
}
